module.exports = __webpack_public_path__ + "media/images/cursors/arrow_left@2x-2a38b0564669035555ffdbd33bf1bce2.png";